import * as React from 'react'
import 'react-dates/initialize'
import styled, { AnyStyledComponent } from 'styled-components'
import I18n from '../../core/i18n'
import * as constants from '../../static/constants'
import * as interfaces from '../../static/interfaces'
import Avatar from '../atoms/HeaderAvatar'

declare var window: interfaces.IWindow
interface IProps {
  guests: any[]
  guide: interfaces.IUser | null
  agent: interfaces.IUser | null
}

const ChatMembersList: React.FC<IProps> = props => {
  return (
    <S.ChatMembersList>
      <h2>{I18n.t('generic.members')}</h2>
      {props.guests.map(guest => (
        <div className="AvatarWrap" key={guest.id}>
          <Avatar user={guest} />
        </div>
      ))}
      {props.agent && (
        <div className="AvatarWrap">
          <Avatar user={props.agent} />
        </div>
      )}
      {props.guide && (
        <div className="AvatarWrap">
          <Avatar user={props.guide} />
        </div>
      )}
    </S.ChatMembersList>
  )
}

const S: { [key: string]: AnyStyledComponent } = {}

S.ChatMembersList = styled.div`
  width: 100%;
  margin-bottom: 16px;
  @media (max-width: ${constants.BREAKPOINT_TABLET_SMALL}px) {
    padding: 16px 12px 12px;
    width: auto;
  }

  > h2 {
    font-size: 18px;
    font-weight: 700;
    color: ${constants.COLORS.subText};
    @media (max-width: ${constants.BREAKPOINT_TABLET_SMALL}px) {
      font-size: 16px;
    }
    padding-bottom: 1rem;
    border-bottom: 1px solid ${constants.COLORS.divider};
  }

  .AvatarWrap {
    padding: 1em 0 1em 0;
    border-bottom: 1px solid ${constants.COLORS.divider};
  }
`

export default ChatMembersList
